module.exports = __webpack_public_path__ + "img/medium.3e01e723.svg";